import React, {Component} from 'react';
import * as apis from '../../utils/apis';
import { connect } from "react-redux";
import DataGrid, {
    Column,
    Editing,
    Popup,
    Position,
    GroupPanel,
    FilterPanel,
    FilterRow,
    ColumnChooser,
    Scrolling,
    RequiredRule,
    FormItem
} from 'devextreme-react/ui/data-grid';
import { StringLengthRule } from 'devextreme-react/validator';


const getHeight = () => {
    return (window.innerHeight - 48)
}

class PRPriorityGrid extends Component {
    state = {
    };

    resize = () => {
        this.gridview.instance.option('height',getHeight());
      }
    
      componentDidMount() {
        window.addEventListener('resize', this.resize)
      }
      
      componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
      }

      setDefaultNewValues = (e) => {
        e.data.default = false;
        e.data.active = true;
        e.data.numericValue = 1;
    }

    onEditorPreparing = (e) =>  {
     
        if (e.parentType === 'dataRow') {
                    
            if(e.dataField === 'numericValue') {
                e.editorName = "dxNumberBox";
                e.editorOptions = { showSpinButtons: true, showClearButton: true, min: 1, max: 99, value: 1 }
                e.editorOptions.onValueChanged = (event) => {
                    var value = event.value;
                    e.setValue(value); 
                }
            }
        }        
    }

    onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
              icon: 'refresh',
              onClick: this.refreshGrid 
            }
          });
    }

    refreshGrid = () => {
        this.gridview.instance.refresh(true);
    }

    render() {
        return  (
            <DataGrid 
            dataSource={apis.PRPriorityDataSource(this.props.user.access_token)}  
            noDataText="There are no part request priorites defined."
            rowAlternationEnabled={true}  
            showBorders={true}
            showRowLines={true}
            showColumnLines={true}  
            columnHidingEnabled={false}
            allowColumnReordering={true}
            allowColumnResizing={true}
            stateStoring={{ enabled: 'true',type: 'localStorage', storageKey: 'prPriority' }}
            height={getHeight }
            width="100%" ref={(gv) => {this.gridview = gv}} 
            onInitNewRow={this.setDefaultNewValues} onEditorPreparing={this.onEditorPreparing} onToolbarPreparing={this.onToolbarPreparing}
         >
         <Editing
            mode={'popup'}
            allowUpdating={this.props.grants.rights.adminPRPriorities}
            allowDeleting={this.props.grants.rights.adminPRPriorities}
            allowAdding={this.props.grants.rights.adminPRPriorities} >
             <Popup title={'Part Request Priority'} showTitle={true} width={700} height={345}>
              <Position my={'center'} at={'center'} of={window} />
            </Popup>
        </Editing>
        <Scrolling mode="virtual" />
        <GroupPanel visible={true} />
        <FilterRow visible={true} />
        <FilterPanel visible ={true} />
  
        <ColumnChooser enabled={true} />
        {/* <StateStoring enabled={true} storageKey="this.props.sectionId" /> */}

        <Column dataField={'id'} visible={false}>
            <FormItem visible={false} />
        </Column>
        <Column dataField={'priority'}>
            <RequiredRule />
            <StringLengthRule max="100" message="The part request priority cannot exceed 100 characters."/>
        </Column>
        <Column dataField={'numericValue'} >
        <RequiredRule />
        </Column>
        <Column dataField={'default'} />
        <Column dataField={'active'} />
 
        </DataGrid>
        );
    }


}

const mapStateToProps = (state) => {
    return {
        user: state.oidc.user,
        grants: state.rights
    };
  }


export default connect(mapStateToProps, null)(PRPriorityGrid)